import Vue from 'vue'

import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';

Vue.component('vue-good-table', VueGoodTable)